"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const FieldErrorShelf_1 = require("../../global/shelves/FieldErrorShelf");
class FormShelf {
    constructor(initialValues) {
        this.handleChange = (field) => (element) => {
            mobx_1.runInAction(() => this.values = Object.assign(Object.assign({}, this.values), { [field]: element.target.value }));
        };
        this.field = (field) => ({
            name: field,
            onChange: this.handleChange(field),
            value: this.values[field],
            error: this.fieldError.getFieldError(field),
        });
        this.getValues = () => this.values;
        this.getValue = (field) => (this.values[field]);
        this.values = initialValues;
        this.fieldError = new FieldErrorShelf_1.default();
        mobx_1.makeAutoObservable(this);
    }
}
exports.default = FormShelf;
